import { render, staticRenderFns } from "./CompanyDescription.vue?vue&type=template&id=c5d5999a&scoped=true&"
import script from "./CompanyDescription.vue?vue&type=script&lang=js&"
export * from "./CompanyDescription.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDescription.vue?vue&type=style&index=0&id=c5d5999a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d5999a",
  null
  
)

export default component.exports